export function formatServiceHost(serviceUrl: string): string {
  try {
    return new URL(serviceUrl).hostname.replace(/^www\./, "");
  } catch {
    return serviceUrl;
  }
}
